import { Directive, Input, OnChanges, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core'
import { AccessFeature } from '@sauna-net/dto'
import { Subscription } from 'rxjs'
import { AccessService } from './access.service'

/**
 * Vykreslí obsah jen uživateli s přístupem k funkci, jinak volitelnou `else` šablonu.
 * Použití: `<ng-container *fsCanAccess="'workGroups'; else noAccess">…</ng-container>`
 */
@Directive({
  selector: '[fsCanAccess]',
  standalone: true,
})
export class CanAccessDirective implements OnChanges, OnDestroy {
  @Input({ required: true }) fsCanAccess!: AccessFeature
  @Input() fsCanAccessElse?: TemplateRef<unknown>

  private subscription?: Subscription
  private rendered?: TemplateRef<unknown>

  constructor(
    private readonly template: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly access: AccessService,
  ) {}

  ngOnChanges() {
    this.subscription?.unsubscribe()
    this.subscription = this.access.can$(this.fsCanAccess).subscribe(allowed => this.render(allowed ? this.template : this.fsCanAccessElse))
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe()
  }

  private render(template?: TemplateRef<unknown>) {
    if (template === this.rendered) return

    this.viewContainer.clear()
    this.rendered = template
    if (template) this.viewContainer.createEmbeddedView(template)
  }
}
